import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  bannerWrapper: {
    display: "block",
    background: "#ffffff",
    padding: 20,
    border: `1px solid ${colour.brand.green}`,
    borderRadius: 10,
    margin: "10px 0",
    position: "relative"
  },
  banner: {
    display: "block",
    fontSize: 14,
    fontWeight: 600,
    color: colour.brand.green,
    paddingLeft: 50,
    textAlign: "left",
    ":before": {
      fontFamily: "informetis",
      fontWeight: 200,
      fontSize: 18,
      color: colour.brand.green,
      content: '"\\E820"',
      position: "absolute",
      left: 20,
      top: "calc(50% - 15px)",
      height: 24,
      width: 30,
      display: "block",
      border: `1px solid ${colour.brand.green}`,
      borderRadius: "50%",
      textAlign: "center",
      paddingTop: 6
    }
  }
});
